import { Dialog, DialogContent, Box, CircularProgress, Typography } from '@mui/material';
import { useConnectionWizard } from '../hooks/useConnectionWizard';

export const DeviceHealthCheck = () => {
  const { isOpen, connectionStatus, deviceHealth } = useConnectionWizard();

  const isVerifying = connectionStatus === 'verifying';

  if (!isVerifying) {
    return null;
  }

  return (
    <Dialog 
      open={isOpen && isVerifying} 
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 4,
        }
      }}
    >
      <DialogContent>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          textAlign="center"
          gap={3}
        >
          <CircularProgress size={60} thickness={4} />
          
          <Box>
            <Typography variant="h6" gutterBottom>
              Verifying device status...
            </Typography>
            
            {deviceHealth && (
              <Typography variant="body2" color="text.secondary">
                Reader {deviceHealth.serialNumber}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
